import { courseGradientPresets } from './landing-data';

export function formatGrades(grades) {
    if (!grades || !grades.length) {
        return '';
    }
    return grades.map((grade) => grade.name).join('، ');
}

export function isCourseFree(course, hidePricingOnIos, platform) {
    if (hidePricingOnIos && platform === 'ios') {
        return false;
    }
    return course.pay_type === 'course' && course.price === 0;
}

export function mapCourseForLandingCard(course, index, { platform } = {}) {
    const preset = courseGradientPresets[index % courseGradientPresets.length];
    const useImage = !!course.image_url;

    return {
        id: course.id,
        name: course.name,
        gradesText: formatGrades(course.grades),
        free: isCourseFree(course, true, platform),
        lecturesCount: course.lectures_count,
        imageUrl: course.image_url,
        overlayTitle: useImage ? null : preset.title,
        overlayLine2: useImage ? null : preset.titleLine2,
        overlaySubtitle: useImage ? null : preset.cardSubtitle,
        overlayIcon: preset.icon,
        bg: preset.bg,
        glow: preset.glow,
        useImage,
    };
}

export function mapCoursesForLanding(courses, options = {}) {
    if (!courses || !courses.length) {
        return [];
    }
    return courses.map((course, index) => mapCourseForLandingCard(course, index, options));
}
